// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Data9 from "common/src/data/Data9.bs.js";
import * as React from "react";
import * as Data18 from "common/src/data/Data18.bs.js";
import * as Data56 from "common/src/data/Data56.bs.js";
import * as Data95 from "common/src/data/Data95.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as TbItemCell from "./TbItemCell.bs.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";

function TbRadiantItemsGrid(Props) {
  var search = Props.search;
  var searchItems = Props.searchItems;
  var set = TftSet.use(undefined);
  React.useState(function () {
        return [];
      });
  return React.createElement("div", undefined, React.createElement("div", {
                  className: "border-l border-t border-white1"
                }, Belt_Array.map(Belt_Array.range(1, 8), (function (i) {
                        return React.createElement("div", {
                                    key: String(i),
                                    className: "flex"
                                  }, Belt_Array.map(Belt_Array.range(1, 8), (function (j) {
                                          var match = set >= 91 ? (
                                              set !== 95 && set === 180 ? Data18.gridRadiantItem(i, j) : Data95.gridRadiantItem(i, j)
                                            ) : (
                                              set !== 56 ? (
                                                  set >= 90 ? Data9.gridRadiantItem(i, j) : Data95.gridRadiantItem(i, j)
                                                ) : Data56.gridRadiantItem(i, j)
                                            );
                                          var tmp = {
                                            search: search,
                                            itemId: match[0],
                                            key: String(Math.imul(i, 10) + j | 0)
                                          };
                                          if (searchItems !== undefined) {
                                            tmp.searchItems = Caml_option.valFromOption(searchItems);
                                          }
                                          return React.createElement("div", {
                                                      key: String(Math.imul(i, 10) + j | 0),
                                                      className: "border-r border-b border-white1"
                                                    }, React.createElement(TbItemCell.make, tmp));
                                        })));
                      }))));
}

var make = TbRadiantItemsGrid;

export {
  make ,
  
}
/* Data9 Not a pure module */
